import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/welcomepet.css";
import petfamLogo from "../assets/Petfamp.png";
import dogHero from "../assets/WelcomePet.webp";
import { X } from "lucide-react";

export default function WelcomePet() {
  const location = useLocation();
  const navigate = useNavigate();

  // Lee la intención de transición que llegó con la navegación previa
  const t = location.state?.transition;

  // Alias por compatibilidad: "screen" / "screen-up" / "up" => entra desde ABAJO
  const screenUp   = t === "screen" || t === "screen-up" || t === "up";
  // "screen-down" / "down" => entra desde ARRIBA
  const screenDown = t === "screen-down" || t === "down";

  // Mientras entra, aplicamos la clase y luego la quitamos
  const [entering, setEntering] = useState(screenUp || screenDown);
  useEffect(() => {
    if (screenUp || screenDown) {
      const id = setTimeout(() => setEntering(false), 420); // igual a tu CSS
      return () => clearTimeout(id);
    }
  }, [screenUp, screenDown]);

  // Clase de animación de pantalla completa según dirección
  const enterClass = entering ? (screenDown ? "is-entering-down" : "is-entering") : "";

  // Ir a Perfil de la mascota: allá solo se anima el panel derecho
  const irPerfilMascota = () =>
    navigate("/perfilmascota", { state: { transition: "panel" } });

  return (
    <div className={`wp-shell ${enterClass}`}>
      {/* Lateral de pasos */}
      <aside className="wp-steps">
        {/* ⟵ Botón de cerrar (va al Home) */}
        <div className="wp-brand">
          <strong>PASOS</strong>
        </div>

        <ol className="steps">
          <li className="step active">Bienvenido</li>
          <li className="step">Perfil de la mascota</li>
        </ol>
      </aside>

      {/* Panel derecho */}
      <main className="wp-main">
        <header className="wp-header">
          <div className="wp-logo-wrap">
            <img src={petfamLogo} alt="Petfam" className="wp-logo" />
          </div>
        </header>

        <section className="wp-hero">
          <figure className="wp-hero-figure">
            <img src={dogHero} alt="Puppy in sling" loading="lazy" />
          </figure>

          <div className="wp-hero-copy">
            <h1 className="wp-title">Bienvenidos</h1>
            <p className="wp-sub">
              Crea el perfil de tu mascota.
            </p>

            <div className="wp-cta single">
              <button type="button" className="btn btn-teal" onClick={irPerfilMascota}>
                Crear
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
